import styled from 'styled-components'
import { colors } from 'client/styles'

export const ErrorBlockBase = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-block: 20px;
  padding-inline: 20px;
`

export const IconWrapper = styled.div`
  align-items: center;
  margin-block-end: 30px;

  svg {
    height: 56px;
    fill: ${colors.grey0};
    width: 65px;
  }
`

export const Text = styled.p`
  align-items: center;
  margin-block-end: 15px;
  line-height: 1.5;
  text-align: center;
`
